﻿import { Component, OnInit, AfterViewInit, Input, OnChanges, SimpleChanges, ViewChild, TemplateRef } from '@angular/core';
import { Errors, LeaderboardService } from '../../../../core';

@Component({
  selector: 'app-leaderboard-activity-challenge',
  templateUrl: './leaderboard-activity-challenge.component.html',
  styleUrls: ['./leaderboard-activity-challenge.component.scss']
})
export class LeaderboardActivityChallengeComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() userData: any;
  @Input() isOptOut: boolean = false;
  @Input() isManager: boolean = false;
  @Input() pamData: any = '';
  @Input() legacyMode: boolean = false;

  @ViewChild('participantTemplate') participantTemplate!: TemplateRef<any>;

  errors: Errors = { errors: {} };
  allChallengeTypes: any;
  currentChallengeTab: number = 0;
  selectedChallenge: any;
  selectedChallengeItem: any;
  displayedChallengeData: any = null;
  leaderboardItemsLoaded: boolean = false;
  activationChallenges: any;
  activationChallengesColumns: any[] = [];
  isLoading: boolean = false;
  activityPage: number = 1;
  activityPageSize: number = 5;
  activitySearchByName: any;
  challengeApiHit: boolean = false;
  challengeResponseFlag: boolean = false;
  pageData: any = {};

  constructor(private leaderboardService: LeaderboardService) { }

  ngOnInit() {
    this.getAllChallengeTypes();
  }

  ngAfterViewInit() {
    setTimeout(() => { this.initializeActivationChallengesTable(); });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['isOptOut'] && !changes['isOptOut'].firstChange) {
      if (this.currentChallengeTab === 3) {
        this.activityPage = 1;
        this.getActivationChallenges();
      }
    }
  }

  getAllChallengeTypes() {
    let beGeoIdReq: string;
    if (this.userData.userType === 'PAM') {
      const actBeGeoIds = this.pamData.pamBeGeoIdsDTO ? this.pamData.pamBeGeoIdsDTO.beGeoIds : this.pamData.beGeoIds;
      const actFirst = (actBeGeoIds.content && actBeGeoIds.content.length > 0) ? actBeGeoIds.content[0] : (actBeGeoIds.length > 0 ? actBeGeoIds[0] : null);
      beGeoIdReq = '&beGeoId=' + (actFirst ? actFirst.beGeoId : this.userData.company.beGeoId);
    } else {
      beGeoIdReq = '&beGeoId=' + this.userData.company.beGeoId;
    }
    this.leaderboardService.getActivityLeaderboardChallengeTypes(beGeoIdReq).subscribe((response) => {
      this.allChallengeTypes = response.filter((item: any) => item.name !== 'Product Booking Challenge');
      if (this.allChallengeTypes.length > 0 && !this.challengeApiHit) {
        this.challengeApiHit = true;
        this.getChallengeLeaderboards(0);
      }
    }, (err) => {
      this.errors = err;
    });
  }

  getChallengeLeaderboards(index: number) {
    const challengeType = this.allChallengeTypes[index];
    challengeType.shortName = challengeType.shortName.toLowerCase() === 'training'
      ? 'enablement'
      : challengeType.shortName.toLowerCase() === 'product bookings'
        ? 'productBookingActivityChallenge'
        : challengeType.shortName.toLowerCase();

    let companyId: any;
    this.userData.hasOwnProperty('userType') && this.userData.userType === 'PAM'
      ? companyId = this.userData.company.id
      : companyId = '';

    this.isLoading = true;
    if (this.isManager) {
      this.leaderboardService.getManagerChallengesByType(this.userData.id, challengeType.shortName, companyId).subscribe((data) => {
        this.isLoading = false;
        if (data) {
          this.selectedChallenge = data;
          this.leaderboardItemsLoaded = false;
          if (data.items && data.items.length > 0) {
            this.selectedChallenge.items = this.formatChallengeItems(data.items);
            this.selectedChallengeItem = this.selectedChallenge.items[0];
            this.leaderboardItemsLoaded = true;
          }
          this.updateDisplayedChallengeData();
          this.challengeResponseFlag = true;
        }
      }, (err) => {
        this.isLoading = false;
        this.errors = err;
      });
    } else {
      this.leaderboardService.getSellerChallengesByType(this.userData.id, challengeType.shortName).subscribe((data) => {
        this.isLoading = false;
        if (data) {
          this.selectedChallenge = data;
          this.leaderboardItemsLoaded = false;
          if (data.items && data.items.length > 0) {
            this.selectedChallenge.items = this.formatChallengeItems(data.items);
            this.selectedChallengeItem = this.selectedChallenge.items[0];
            this.leaderboardItemsLoaded = true;
          }
          this.updateDisplayedChallengeData();
          this.challengeResponseFlag = true;
        }
      }, (err) => {
        this.isLoading = false;
        this.errors = err;
      });
    }
  }

  formatChallengeItems(items: any[]): any[] {
    if (!items) { return []; }
    return items.map((item: any) => ({
      ...item,
      displayName: item.challengeName + ' (' + item.id + ')'
    }));
  }

  private updateDisplayedChallengeData(): void {
    if (!this.selectedChallenge) {
      this.displayedChallengeData = null;
      return;
    }
    if (!this.selectedChallengeItem) {
      this.displayedChallengeData = this.selectedChallenge;
      return;
    }
    this.displayedChallengeData = { ...this.selectedChallenge, items: [this.selectedChallengeItem] };
  }

  selectChallenge(item: any) {
    const index = this.allChallengeTypes.indexOf(item);
    this.currentChallengeTab = index;
    this.selectedChallengeItem = null;
    this.displayedChallengeData = null;
    this.leaderboardItemsLoaded = false;
    if (index === 5) {
      this.activityPage = 1;
      this.activitySearchByName = '';
      return this.getActivationChallenges();
    }
    this.getChallengeLeaderboards(index);
  }

  selectChallengeItem(item: any): void {
    this.selectedChallengeItem = item;
    this.updateDisplayedChallengeData();
  }

  getActivationChallenges(index?: any, pageNo?: any) {
    this.pageData[index] = [index, pageNo];
    if (pageNo) {
      this.activityPage = pageNo;
    }
    const params = {
      page: this.activityPage - 1,
      size: this.activityPageSize,
    };
    this.isLoading = true;
    this.leaderboardService.getActivationChallenges(this.userData.company.id, params).subscribe((data) => {
      this.isLoading = false;
      if (data) {
        this.activationChallenges = data;
        this.challengeResponseFlag = true;
      }
    }, (err) => {
      this.isLoading = false;
      this.errors = err;
    });
  }

  initializeActivationChallengesTable() {
    const participantCol: any = { field: 'participant', header: 'Participant' };
    if (this.participantTemplate) { participantCol.cellTemplate = this.participantTemplate; }

    this.activationChallengesColumns = [
      { field: 'rank', header: 'Rank', align: 'center', isBold: true },
      participantCol,
      { field: 'activationsClaimed', header: 'Activations', align: 'right', isBold: true, numberFormat: true },
      { field: 'pointsEarned', header: 'Points Earned', align: 'right', highlight: 'green', isBold: true, numberFormat: true }
    ];
  }

  onActivationChallengesPageChange(newPage: number) {
    this.activityPage = newPage;
    this.getActivationChallenges(undefined, newPage);
  }

  splitData(value: any): string {
    const parseValue = parseFloat(value);
    if (isNaN(parseValue)) { return '0'; }
    return parseValue.toLocaleString('en-US');
  }
}
